import { AuthenticationManager } from '@frontend/authentication-v2';
import { Dropdown, DropdownItem } from '@frontend/components/common';
import { User } from '@frontend/user/utils';
import { useState } from 'react';
import { LuLogOut } from 'react-icons/lu';

import useAccountMembership from './account-membership.controller';

interface Props {
    className?: string;
    buttonStyle?: string;
}

const AccountMembership = (props: Props) => {
    const viewProps = useAccountMembership();
    const [showUserMenu, setShowUserMenu] = useState(false);

    return (
        <div className='flex h-full items-stretch'>
            {/* Profile section */}
            <div className='relative'>
                <button
                    onClick={() => setShowUserMenu((prev) => !prev)}
                    className='border-border-default hover:bg-brand-light flex h-full cursor-pointer items-center gap-3 border-l px-5'>
                    <div className='bg-brand-primary text-always-white flex size-10 shrink-0 items-center justify-center rounded-full text-lg font-medium'>
                        {viewProps.user ? new User(viewProps.user).getInitials() : '?'}
                    </div>
                    <div className='flex flex-col text-left'>
                        <span className='text-foreground-default text-base font-semibold'>
                            {viewProps.user ? new User(viewProps.user).getDisplayName() : 'User'}
                        </span>
                        <span className='text-brand-muted text-xs font-medium'>{viewProps.user?.unique_identifier}</span>
                    </div>
                </button>

                {showUserMenu && (
                    <>
                        {/* Backdrop to close menu */}
                        <div
                            className='fixed inset-0 z-40'
                            onClick={() => setShowUserMenu(false)}
                        />
                        <div className='bg-background-surface border-border-default absolute top-full right-0 z-50 mt-1 w-48 overflow-hidden rounded-lg border shadow-lg'>
                            <button
                                onClick={() => AuthenticationManager.getInstance().doLogout()}
                                className='hover:bg-background-default text-foreground-default flex w-full items-center gap-3 px-4 py-3 text-left text-sm font-medium'>
                                <LuLogOut className='size-4 shrink-0' />
                                Sign out
                            </button>
                        </div>
                    </>
                )}
            </div>

            {/* Account membership */}
            {viewProps.accounts.length > 1 ? (
                <Dropdown
                    hideChevron
                    buttonStyle={
                        props.buttonStyle ??
                        'border-border-default text-brand-muted flex items-center h-full border-l px-5 cursor-pointer uppercase font-extrabold hover:bg-brand-light'
                    }
                    className={props.className}
                    label={viewProps.isSwitching ? 'Switching…' : (viewProps.selectedAccount?.name ?? 'Select account')}
                    styles={{
                        button: { background: 'bg-brand-light' },
                        nested: { text: 'text-brand-light' },
                        label: { text: 'font-extrabold text-brand-muted' }
                    }}>
                    {viewProps.accounts.map((acc) => (
                        <DropdownItem
                            key={acc.id}
                            label={acc.name}
                            className='text-brand-muted'
                            onClick={() => {
                                if (!viewProps.isSwitching) {
                                    viewProps.onChangeMembership(acc.id);
                                }
                            }}
                        />
                    ))}
                </Dropdown>
            ) : (
                <div
                    id={`${viewProps.selectedAccount?.name.toString().toLocaleLowerCase().replace(' ', '-')}-button`}
                    className='text-brand-muted border-border-default flex h-full items-center border-l px-5 font-extrabold uppercase'>
                    {viewProps.selectedAccount?.name}
                </div>
            )}
        </div>
    );
};

export default AccountMembership;
